import * as React from 'react'
import { useEffect, useMemo } from 'react'
import { FilterTypeRadioProps } from '../types'
import { Filter } from '../Filter'
import { RadioFilterContent } from './RadioFilterContent'
import { useFilterCallbacks } from '../useFilterCallbacks'
import { WidgetSpinner } from '../../Spinner/Spinner'

export const RadioFilter: React.FC<FilterTypeRadioProps> = (props) => {
    const {
        value: initialValue,
        defaultValue,
        onChange,
        isLoading,
        isError,
        className,
    } = props

    const {
        currentValue,
        setCurrentValue,
        onValueSave,
        onValueReset,
        resetState,
    } = useFilterCallbacks(initialValue, defaultValue, onChange)

    const selectedOption = useMemo(() => {
        return props.config.options?.find((opt) => opt.value === initialValue)
    }, [initialValue, props.config.options])

    const valueLabel = useMemo(() => {
        if (isLoading) {
            return <WidgetSpinner />
        }
        if (props.valueLabel) {
            return props.valueLabel
        }

        if (selectedOption) {
            return selectedOption.label
        }
        return typeof initialValue === 'string' ? initialValue : ''
    }, [initialValue, isLoading, props.valueLabel, selectedOption])

    useEffect(() => {
        const options = props.config.options

        if (!selectedOption && options && options[0]) {
            onChange(options[0].value)
        }
    }, [
        defaultValue,
        onChange,
        onValueReset,
        props.config.options,
        selectedOption,
    ])

    return (
        <Filter
            {...props}
            valueLabel={valueLabel}
            onValueSave={onValueSave}
            onValueReset={onValueReset}
            resetState={resetState}
            options={props.config.options}
            isLoading={isLoading}
            isError={isError}
            className={className}
        >
            <RadioFilterContent
                {...props}
                value={currentValue}
                onChange={setCurrentValue}
            />
        </Filter>
    )
}
